// extracted by mini-css-extract-plugin
export default {"matrix-table--pad3":"p_bz ml-3","matrix-table--pad4":"p_bB ml-5","matrix-table__title":"p_bC","matrix-table__true":"p_bD","matrix-table__false":"p_bF"};